module.exports = __webpack_public_path__ + "img/step7.b0307553.jpg";